import React from 'react'
import Page from 'layout/page'
import PageTitle from 'layout/page-title'
import SettingsPanels from './panels'

// Settings within the analytics app shell.
function Settings() {
  return (
    <Page title="Settings">
      <PageTitle />
      <SettingsPanels />
    </Page>
  )
}

export default Settings
